import React, { useEffect, useState } from 'react';
import Button from '../../../../ui-core/Button/Button';
import { useFormik } from 'formik';
import EmailIcon from '../../../../static/images/signup/Email.svg';
import * as Yup from 'yup';
import { checkForUniqueness } from '../../../../api/user';
import { getItem, setItem } from '../../../../utils/cache';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../../../services/Notification';
import { MODAL_TYPE } from '../../../../constants/app';
import { useModal } from '../../../../context/ModalContext';
import { useDispatch } from 'react-redux';
import { doSendMergeOtpRequest } from '../../../../store/action/auth';
import PropTypes from 'prop-types';

const AddEmailModal = ({ handleModalState }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { openModal } = useModal();
  const dispatch = useDispatch();
  const isConfirmPhoneModal = getItem('AccountMerge');

  useEffect(() => {
    if (isConfirmPhoneModal) {
      handleModalState(null);
    }
  }, [isConfirmPhoneModal]);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        `You've entered an invalid email, please try another one.`,
      )
      .required('Please enter email.'),
  });

  const checkUniqueEmail = async values => {
    try {
      setIsLoading(true);
      const payload = {
        type: 'email',
        email: values?.email,
      };
      const response = await checkForUniqueness(payload);
      setIsLoading(false);
      return response.data;
    } catch (error) {
      setIsLoading(false);
      return error?.response?.data?.response?.errors[0] || error?.message;
    }
  };

  const submit = async values => {
    const error = await checkUniqueEmail(values);
    const emailDetails = {
      email: values?.email,
    };
    setItem('mergeEmailDetail', JSON.stringify(emailDetails));
    if (error) {
      createNotification({
        type: NOTIFICATION_TYPE.ERROR,
        message: error,
      });
      openModal(MODAL_TYPE.CONFIRM_EMAIL);
    } else {
      dispatch(
        doSendMergeOtpRequest({
          data: {
            type: 'email',
            email: values?.email,
          },
          callback: () => handleModalState(MODAL_TYPE.EMAIL_OTP),
        }),
      );
    }
  };

  const { errors, handleSubmit, setFieldValue, touched } = useFormik({
    validationSchema,
    onSubmit: submit,
    initialValues: {
      email: '',
    },
  });

  return (
    <>
      <div className="form-h">
        <h2 className="sign-in-h1">Enter Email </h2>
        <p className="sign-in-h3 mb-4 mt-4 pb-3">
          We notice your account doesn&#39;t have an email address yet. Please
          enter your email address to continue.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="email_input">
            <label htmlFor="email" className="text-uppercase sign_label">
              EMAIL ADDRESS
            </label>
            <div className="mt-2 email_input_text d-flex gap-0">
              <img src={EmailIcon} alt="email icon" />
              <input
                type="text"
                name="email"
                id="email"
                className="border-0 ms-2 w-100 sign_up_input"
                placeholder="Enter email"
                onChange={event => setFieldValue('email', event.target.value)}
              />
            </div>
            {!!errors?.email && !!touched?.email && (
              <span className="text-danger error-text">{errors?.email}</span>
            )}
          </div>

          <Button
            text="CONTINUE"
            class={`OtpButton ${isLoading && ''}`}
            isDisabled={isLoading}
            isLoading={isLoading}
          />
        </form>
      </div>
    </>
  );
};

AddEmailModal.propTypes = {
  handleModalState: PropTypes.func,
};

export default AddEmailModal;
